/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect} from 'react';
import {Button, Divider, Form, Input, Radio, Select, Switch} from "antd";
import styles from './Search.module.scss';
import {emptyGetBaechaListParams} from "../BaechaList2.interface";
import {useBaechaList2Store} from "../../../stores/baechaList2Store";
import {BaechaWorkDayStatusEnum} from "../../../types/Type";

const Search = () => {
	const filter = useBaechaList2Store((s) => s.filter);
	const setFilter = useBaechaList2Store((s) => s.setFilter);

	const [form] = Form.useForm();

	const handleFinish = (values: any) => {
		const cleanedValues = Object.entries(values).reduce((acc, [key, value]) => {
			if (value !== '' && value !== null && value !== undefined) {
				acc[key] = value;
			}
			return acc;
		}, {} as any);

		setFilter(cleanedValues);
	};

	useEffect(() => {
		form.setFieldsValue(filter);
	}, [form, filter]);

	return (
		<div className={styles.wrap}>
			<Form
				form={form}
				onFinish={handleFinish}
				className={styles.formWrap}
				layout="inline"
			>
				<div className={styles.left}>
					<Form.Item name="baechaNo">
						<Input placeholder="배차 번호" allowClear style={{ width: 100 }} />
					</Form.Item>

					<Form.Item name="baechaStatus">
						<Select
							mode="multiple"
							placeholder="배차 상태"
							style={{ width: 100 }}
							allowClear
							options={[
								{ value: 'balju', label: '발주' },
								{ value: 'suju', label: '수주' },
								{ value: 'complete', label: '완료' },
								{ value: 'save', label: '임시' },
								{ value: 'designated_reject', label: '지명 거절' },
								{ value: 'suju_zero', label: '수주 없음' },
								{ value: 'balju_cancel', label: '발주 취소' },
								{ value: 'delete', label: '삭제' },
							]}
						/>
					</Form.Item>

					<Form.Item name="baechaWorkDayStatus">
						<Select
							placeholder="완료작업 추가요청"
							style={{ width: 150 }}
							allowClear
							options={[
								{ value: BaechaWorkDayStatusEnum.SAVE, label: '임시저장' },
								{ value: BaechaWorkDayStatusEnum.REQUEST, label: '승인요청' },
								{ value: BaechaWorkDayStatusEnum.CANCEL, label: '요청취소' },
								{ value: BaechaWorkDayStatusEnum.APPROVE, label: '승인' },
								{ value: BaechaWorkDayStatusEnum.REJECT, label: '승인거절' },
							]}
						/>
					</Form.Item>

					<Form.Item name="baechaRegion">
						<Input placeholder="배차 지역" allowClear style={{ width: 150 }} />
					</Form.Item>

					<Form.Item name="groupName">
						<Input placeholder="배차방명" allowClear style={{ width: 150 }} />
					</Form.Item>

					<Divider type="vertical" style={{ marginRight: '24px' }} />

					<div style={{ display: 'flex', flexDirection: 'row', background: '#F8F8F8', padding: '8px', borderRadius: '8px' }}>
						<Form.Item name="name">
							<Input placeholder="이름" allowClear style={{ width: 120 }} />
						</Form.Item>

						<Form.Item name="nickname">
							<Input placeholder="닉네임" allowClear style={{ width: 120 }} />
						</Form.Item>

						<Form.Item name="phoneNum">
							<Input placeholder="전화번호" allowClear style={{ width: 150 }} />
						</Form.Item>

						<Form.Item name="scope">
							<Radio.Group
								options={[
									{ value: 'all', label: '모두' },
									{ value: 'balju', label: '발주' },
									{ value: 'suju', label: '수주' },
								]}
								optionType="button"
								buttonStyle="solid"
							/>
						</Form.Item>
					</div>

					{/*<Form.Item name="isMultipleMatchedWithin90">*/}
					{/*	<Switch*/}
					{/*		defaultChecked={false}*/}
					{/*		checkedChildren="겹치는 수발주"*/}
					{/*		unCheckedChildren="겹치는 수발주"*/}
					{/*	/>*/}
					{/*</Form.Item>*/}

					<Form.Item name="isFirstBaljuPointNotReceived">
						<Switch
							defaultChecked={false}
							checkedChildren="첫발주 이벤트"
							unCheckedChildren="첫발주 이벤트"
						/>
					</Form.Item>
				</div>


				<div className={styles.right}>
					<Button type="primary" htmlType="submit">
						검색
					</Button>

					<Button
						onClick={() => {
							form.resetFields();
							setFilter(emptyGetBaechaListParams);
						}}
					>
						초기화
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default Search;
